import { useAuth } from "@clerk/clerk-react";
import type { SupabaseContextType } from '@neum/frontend-shared/supabase/supabaseTypes';
import { defaultSupabaseContext } from "@neum/frontend-shared/supabase/supabaseUtils";
import { useSupabaseContext } from '@neum/frontend-shared/supabase/useSupabaseContext';
import React, { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';

const SupabaseContext = createContext<SupabaseContextType>(defaultSupabaseContext);

export const useSupabase = () => useContext(SupabaseContext);

interface SupabaseProviderProps {
    children: ReactNode;
}

export const SupabaseProvider: React.FC<SupabaseProviderProps> = ({ children }) => {
    const { context } = useSupabaseContext({ useAuth, useEffect, useMemo, useState })
    return <SupabaseContext.Provider value={context}>{children}</SupabaseContext.Provider>;
};
